<div class="root-container">
  <div class="image-container">

  </div>
  <div class="ruler-container" *ngIf="pathwayWithComment|async as pathway">
    <label class="pathway-label">{{model.pathway !== pathway.gene ? model.pathway :  model.pathway + pathway.label.content}}</label>
    <div class="ruler-gradient" *ngIf="qcPassed">
      <div class="drop-img" [style.left]="scorePosition">
        <p class="text-image">{{score}}</p>
      </div>
      <div class="score-range" [style.width]="width" [style.margin-left]="rangeLeft">
        <div class="score-range__edge"></div>
        <div class="score-range__line"></div>
        <div class="score-range__edge"></div>
      </div>
      <div *ngFor="let i of [0,1,2,3]" class="vertical-line"></div>
    </div>
    <div class="qc-failed" *ngIf="!qcPassed">
      Undetermined
    </div>
  </div>
</div>
